module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/4c1527fc44e5aedde7179e9b10837f1c.png";